<template>
  <v-dialog v-if="showDialog" v-model="showDialog" persistent scrollable max-width="600px">
    <template v-slot:default>
      <v-card class="modal-add-folder">
        <header class="header">
          <CustomDialogHeaderComponent :headerTitle="texts.title" />
        </header>
        <v-card-text style="height: 450px">
          <TemplateSelectorTreeComponent
            :idEntityType="idEntityType"
            @templateSelected="getTemplateSelected"
            :loading="treeLoading"
            :key="componentKey"
            :generateTemplate="generatingTemplate"
          />
        </v-card-text>
        <v-card-actions class="modal-footer">
          <div class="right">
            <button @click.stop="close" class="button secondary-action-button" :title="texts.cancel">
              {{ texts.cancel }}
            </button>
            <button
              v-if="hasSelectedTemplate"
              @click.stop="generate"
              class="button main-action-button"
              :title="texts.generate"
            >
              {{ texts.generate }}
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script lang="ts" setup>
// IMPORTS ==========================================================
import { ref, computed } from 'vue'
import TemplateSelectorTreeComponent from '@/components/template/TemplateSelectorComponent/TemplateSelectorTreeComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import type { ITemplate } from '@/store/modules/template/templateTypes'
import { useI18n } from 'vue-i18n-composable'

const { t } = useI18n()

// DEFINE PROPS ==========================================================
const props = defineProps({
  showDialog: {
    type: Boolean,
    required: true
  },
  idEntityType: {
    type: [Number, String],
    required: true
  }
})

// EVENTS ==========================================================
const emit = defineEmits(['closeTemplateDialog', 'generateTemplateDialog'])

// DATA ==========================================================
const generatingTemplate = ref(false)
const templateSelected = ref<ITemplate | null>(null)
const componentKey = ref(0)
const treeLoading = ref(false)

const texts = {
  title: t('components.file_manager.dialogs.select_template').toString(),
  cancel: t('action_buttons.cancel').toString(),
  generate: t('action_buttons.generate').toString()
}

// COMPUTED ==========================================================
const hasSelectedTemplate = computed(() => {
  return templateSelected.value !== null
})

// METHODS ==========================================================
const updateComponent = async () => {
  componentKey.value += 1
  return componentKey.value
}

const getTemplateSelected = (template: ITemplate) => {
  templateSelected.value = template
}

const close = () => {
  templateSelected.value = null
  emit('closeTemplateDialog')
}

const generate = () => {
  emit('generateTemplateDialog', templateSelected.value)
  templateSelected.value = null
  generatingTemplate.value = true
  treeLoading.value = true
  updateComponent().then(() => {
    treeLoading.value = false
    generatingTemplate.value = false
  })
}
</script>
<style lang="scss" scoped>
@import '~@/styles/partials/components/modal/main';
</style>
